import {Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MenuApiService} from '@emm/menu/services/menu-api.service';
import {BehaviorSubject} from "rxjs";

@Component({
    selector: 'emm-view-overrides-dialog',
    templateUrl: './view-overrides-dialog.component.html',
    styleUrls: ['./view-overrides-dialog.component.scss']
})
export class ViewOverridesDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    submenu = this.data.selectedSubmenu;
    attribute = this.data.attribute.jsonProperty;
    itemPath = this.data.itemPath;
    effectiveDate = this.data.effectiveDate;
    childPath;
    parentPath = `/${this.submenu}/${this.data.itemTag}`;
    overrides;
    formattedOverrides = [];
    displayedColumns = ['key', 'value'];


    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<ViewOverridesDialogComponent>,
        private api: MenuApiService) {
    }

    ngOnInit(): void {
        this.removeSubmenuFromPath();
        this.getOverrides();
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    removeSubmenuFromPath() {
        const path = this.itemPath.split('/');
        path.shift();
        path.shift();
        this.childPath = `/${path.join('/')}`;
        return this.childPath;
    }

    async getOverrides() {
        this.api.getAttributeOverrides(this.attribute, this.submenu, this.childPath, this.effectiveDate)
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(
            res => {
                const keys = [];
                const values = [];
                Object.keys(res).forEach(key => {
                    keys.push(key);
                });
                Object.values(res).forEach(value => {
                    values.push(value);
                });
                for (let i = 0; i < keys.length; i++) {
                    this.formattedOverrides.push({key: keys[i], value: values[i]});
                }
            }
        );
        await this.overrides;
    }
}
